import React from 'react'
import { Button } from 'react-bootstrap'

const AnalyticsPdfNoAccessState = ({ onUpgrade }) => (
  <div className="text-center p-5 my-4 bg-light rounded">
    <h5 className="mb-2">Upgrade to access PDF analytics</h5>
    <p className="text-muted mb-3 mx-auto" style={{ maxWidth: '400px' }}>
      Get detailed insights on PDF page views and time spent by upgrading your account.
    </p>
    <Button variant="purple" onClick={onUpgrade}>
      Upgrade to unlock →
    </Button>
  </div>
)

export default AnalyticsPdfNoAccessState
